<div class="col-xxl-8 box-col-8 team-learnings">
  <div class="card" style="margin-bottom: 5px;">
    <div class="card-head d-flex justify-content-between" style="padding: 10px;">
      <div class="card-head-text d-flex">
        <span>My Team Learnings</span>
        <span class="material-symbols-outlined fs-16 info" [matTooltip]="toottipText">info</span>
      </div>
      <button class="view-button h5" (click)="teamCourseDetailsNavigate()">View all<i
          class="fa fa-angle-double-right"></i></button>
    </div>
    <hr style="margin: 0;">
    <div class="card-content pl-4 pr-4 row" style="padding-bottom: 0.5rem; margin-top: 5px;">
      <div class="card col myTeamLearningsCard" style="padding: 0 !important;">
        <div class="card-head d-flex justify-content-between">
          <span class="card-head-text">Completed</span>
          <span class="head-helper">Count</span>
        </div>
        <hr class="hr">
        <div class="card-content pb-2 pt-1 child-carousel">
          <div *ngIf="myTeamCourseCount?.length == 0" class="no-learners"><span style="color:darkgrey;;">No
              Learners</span></div>
          <p-carousel *ngIf="myTeamCourseCount?.length != 0" [class.custom_carousel]="myTeamCourseCount?.length <= 3"
            #carousel1 [value]="myTeamCourseCount" [numVisible]="3" [numScroll]="1" [showIndicators]="false"
            [showNavigators]="false" verticalViewPortHeight="205px" orientation="vertical">
            <ng-template let-learner pTemplate="item" class="d-flex">
              <div class="top-learners">
                <div class="d-flex mt-2">
                  <div class="col-9 font">
                    <img src="../../../../assets/images/employeeCareer/user.png">
                    <span class="pl-2 learner-name">{{learner.employeeName}}</span>
                  </div>
                  <div class="col-3 font">
                    <span style="text-align: right;">{{learner.completed}}</span>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-carousel>
        </div>
        <div *ngIf="myTeamCourseCount?.length != 0" class="d-flex justify-content-end navigations">
          <button (click)="navigateBackward($event,carousel1,carousel1Index)" class="navigate-button pr-2"
            [disabled]="isBackwardDisabled(carousel1Index)">
            <i class="fa fa-angle-left cursor-pointer"></i></button>
          <button (click)="navigateForward($event, carousel1, carousel1Index)" class="navigate-button"
            [disabled]="isForwardDisabled(carousel1, carousel1Index)"><i
              class="fa fa-angle-right cursor-pointer"></i></button>
        </div>
      </div>
      <div class="card col myTeamLearningsCard" style="padding: 0 !important;">
        <div class="card-head d-flex justify-content-between">
          <span class="card-head-text">In Progress</span>
          <span class="head-helper">Count</span>
        </div>
        <hr class="hr">
        <div class="card-content pb-2 pt-1 child-carousel">
          <div *ngIf="myTeamCourseCount?.length == 0" class="no-learners"><span style="color:darkgrey;;">No
              Learners</span></div>
          <p-carousel *ngIf="myTeamCourseCount?.length != 0" [class.custom_carousel]="myTeamCourseCount?.length <= 3"
            #carousel2 [value]="myTeamCourseCount" [numVisible]="3" [numScroll]="1" [showIndicators]="false"
            [showNavigators]="false" verticalViewPortHeight="205px" orientation="vertical">
            <ng-template let-learner pTemplate="item">
              <div class="top-learners">
                <div class="d-flex mt-2">
                  <div class="col-9 font">
                    <img src="../../../../assets/images/employeeCareer/user.png">
                    <span class="pl-2 learner-name">{{learner.employeeName}}</span>
                  </div>
                  <div class="col-3 font">
                    <span style="text-align: right;">{{learner.inProgress}}</span>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-carousel>
        </div>
        <div class="d-flex justify-content-end navigations" *ngIf="myTeamCourseCount?.length != 0">
          <button (click)="navigateBackward($event,carousel2, carousel2Index)" class="navigate-button pr-2"
            [disabled]="isBackwardDisabled(carousel2Index)">
            <i class="fa fa-angle-left cursor-pointer"></i></button>
          <button (click)="navigateForward($event,carousel2, carousel2Index )" class="navigate-button"
            [disabled]="isForwardDisabled(carousel2, carousel2Index)"><i
              class="fa fa-angle-right cursor-pointer"></i></button>
        </div>
      </div>
      <div class="card col myTeamLearningsCard" style="padding: 0 !important;">
        <div class="card-head d-flex justify-content-between">
          <span class="card-head-text">Not Started</span>
          <span class="head-helper">Count</span>
        </div>
        <hr class="hr">
        <div class="card-content pb-2 pt-1 child-carousel">
          <div *ngIf="myTeamCourseCount?.length == 0" class="no-learners"><span style="color:darkgrey;;">No
              Learners</span></div>
          <p-carousel *ngIf="myTeamCourseCount?.length != 0" [class.custom_carousel]="myTeamCourseCount?.length <= 3"
            #carousel3 [value]="myTeamCourseCount" [numVisible]="3" [numScroll]="1" [showIndicators]="false"
            [showNavigators]="false" verticalViewPortHeight="205px" orientation="vertical">
            <ng-template let-learner pTemplate="item">
              <div class="top-learners">
                <div class="d-flex mt-2">
                  <div class="col-9 font">
                    <img src="../../../../assets/images/employeeCareer/user.png">
                    <span class="pl-2 learner-name">{{learner.employeeName}}</span>
                  </div>
                  <div class="col-3 font">
                    <span style="text-align: right;">{{learner.notstarted}}</span>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-carousel>
        </div>
        <div class="d-flex justify-content-end navigations" *ngIf="myTeamCourseCount?.length != 0">
          <button (click)="navigateBackward($event,carousel3, carousel3Index)" class="navigate-button pr-2"
            [disabled]="isBackwardDisabled(carousel3Index)">
            <i class="fa fa-angle-left cursor-pointer"></i></button>
          <button (click)="navigateForward($event,carousel3, carousel3Index)" class="navigate-button"
            [disabled]="isForwardDisabled(carousel3, carousel3Index)"><i
              class="fa fa-angle-right cursor-pointer"></i></button>
        </div>
      </div>
    </div>
  </div>
</div>
